import React from 'react'
import useCards from '../../../hooks/useCards'

const ProteccionFinancieraCards = () => {
  const { homeinCards } = useCards()
  
  return (
      <>
          {homeinCards(8)}

      </>
  )
} 

export default ProteccionFinancieraCards